import { createOfferResponse, type OpenShift } from "@clipboard-health/contract-worker-app-bff";
import { type InAppAdAttributesSchema } from "@src/appV2/FeatureFlags/CbhFeatureFlags";
import { type z } from "zod";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line no-barrel-files/no-barrel-files
export {
  API_TYPES,
  type GetOpenShiftsResponse,
  type Offer,
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line no-barrel-files/no-barrel-files
  type OpenShift,
  // Alias to avoid conflicts with other Workplace types
  type Workplace as OpenShiftWorkplace,
  type RateNegotiation,
  TimeSlot,
  Urgency,
  Window,
} from "@clipboard-health/contract-worker-app-bff";

export type InferedInAppAdAttributesSchema = z.infer<typeof InAppAdAttributesSchema>;

// Define injected content types for the shift list
export type OpenShiftListItem =
  | (OpenShift & { type: "open-shift" })
  | (InferedInAppAdAttributesSchema & { type: "in-app-ad" })
  | { type: "fortune-cookie"; start?: string };

export const shiftOfferSchema = createOfferResponse.shape.data;
export type ShiftOffer = z.infer<typeof shiftOfferSchema>;
